import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { Box, CloseButton, Text, Flex } from "@chakra-ui/react";

// Create Context
const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [banner, setBanner] = useState({
    isVisible: false,
    message: "",
    type: "info",
    component: null,
    autoHideTime: null,
  });
  
  const timeoutRef = useRef(null);

  const showBanner = (message, type = "info", component = null, autoHideTime = null) => {
    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    
    setBanner({ isVisible: true, message, type, component, autoHideTime });
    
    // Set auto-hide timeout if specified
    if (autoHideTime && autoHideTime > 0) {
      timeoutRef.current = setTimeout(() => {
        hideBanner();
      }, autoHideTime);
    }
  };

  const hideBanner = () => {
    // Clear timeout when manually hiding
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setBanner({ ...banner, isVisible: false });
  };
  
  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <BannerContext.Provider value={{ showBanner, hideBanner , isVisible: banner.isVisible }}>
      {banner.isVisible && (
        <Box
          bg={banner.type === "error" ? "red.500" : banner.type === "success" ? "green.500" : "dark.900"}
          color="dark.100"
          mt={2}
          minH="5vh"
          position="fixed"
          top={{ base: "16vh", md: "14vh" }}
          left={0}
          right={0}
          transform={banner.isVisible ? "translateY(0)" : "translateY(20px)"}
          transition="all 0.3s ease"
          zIndex="2"
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={2}
        >
          <Flex align="center" flexWrap="wrap"  px={12}>
            <Text fontSize="lg" fontWeight="bold">{banner.message}</Text>
            {banner.component && <Box ml={12}>{banner.component}</Box>}
          </Flex>
          <CloseButton size="lg" position="absolute" top={{base:0,md:"2"}} right={{base:"8", md:"12"}} onClick={hideBanner} />
        </Box>
      )}
      {children}
    </BannerContext.Provider>
  );
};

// Hook to use Banner Context
export const useBanner = () => useContext(BannerContext);